import { render } from "./multiplexBoxesInfo.vue?vue&type=template&id=e8d20f40"
import script from "./multiplexBoxesInfo.vue?vue&type=script&lang=js"
export * from "./multiplexBoxesInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__